/** @module Quality/NewFromTestRunTemplate */
define([
	"dojo/_base/declare",
	"csi/def",
	"./NewFromTestRun"
], function(declare,def,NewFromTestRun) {

	return declare(NewFromTestRun, {
	    /**
	     * @override
	     * disable Save & Go since action can create multiple SKUs
	     */
	    _canNavigate: function() {
	        return false;
	    },
	    
	    /**
	     * @override
	     * hide/disable fields based on view
	     */
	    onCreatePopup: function(view) {
			if(view.defView.m_id == def.DEFAULT_FORM_ID) {
				// hide Test Group field
			    this._hideFields(view.defView);
			}
			this.inherited(arguments);
		}
	});
});